import clsx from 'clsx';
import LegacySemanticUiIcon, {
  IconName,
} from 'components/common/LegacySemanticUiIcon/LegacySemanticUiIcon';
import { CSSProperties, InputHTMLAttributes } from 'react';

import styles from './Input.module.css';

interface InputIcon {
  name: IconName;
  /** Show the icon as clickable */
  link?: boolean;
  onClick?: () => void;
}

type InputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'className' | 'style'
> & {
  /** Class name of the element that wraps the input */
  className?: string;
  /** Style of the element that wraps the input */
  style?: CSSProperties;
  /** Props passed to the input element itself */
  input?: { style?: CSSProperties; className?: string };
  /** An icon shown on the right side of the input */
  icon?: InputIcon;
  /** Take up the full width of the parent container */
  fluid?: boolean;
};

const Input = ({
  className,
  style,
  input,
  icon,
  fluid,
  type = 'text',
  ...inputProps
}: InputProps) => (
  <div
    className={clsx(
      styles.input,
      icon && styles.iconInput,
      fluid && styles.fluid,
      className,
    )}
    style={style}
  >
    <input
      {...inputProps}
      type={type}
      className={clsx(styles.inputField, input?.className)}
      style={input?.style}
    />
    {icon && (
      <LegacySemanticUiIcon
        name={icon.name}
        link={icon.link}
        className={styles.icon}
        onClick={icon.onClick}
      />
    )}
  </div>
);

export default Input;
